export const TYPE_STEPS = Object.freeze({
  yourIdentification: 1,
  theEnd: 2,
});
